import { mountAlertModal, mountLogoutModal, mountCustomerSurveyModal, mountProUpgradeModal } from "./modal";
import { isVacationLimitMaxedOut } from "./shift";
import { isNonWorkingSlotType } from "./slot_helpers";
import { MODAL_ID } from '../js/modal.js'
import { mountBranchSelectorComponent } from "./branch_menu";

import { createApp } from "vue";
import { i18n } from "../i18n";
import NotificationDropdown from "../view/components/notificationDropdown/NotificationDropdown.vue";
import { NotificationType } from "../view/components/notificationDropdown/type/notificationType";
import { clearSlotInSlotLogMap, updateSlotUnreadCommentBadge } from "./slotLog";
import GroupLevelSidebar from "../view/components/groupLevelSidebar/GroupLevelSidebar.vue";
import { GroupLevelSidebarApp } from "../app/groupLevelSidebarImpl";
import Toast from "../vue/components/Toast.vue";

export function initPage(props) {
  mountToast();
  mountAlertModal();
  mountLogoutModal();
  mountProUpgradeModal();
  watchForHubSpotIframes();
  mountNotificationDropdown({
    branchId: props.activeBranchId,
    userId: props.activeUser ? props.activeUser.ID : null,
    hasBoardPermission: props.hasBoardPermission,
    hasSummaryPermission:
      props.activeUser &&
      !(props.hasBranchPermission || props.isGroupEditor) &&
      props.activeBranchId &&
      !props.isBranchOrGroupOwner,
    goToSummary:
      props.hasBranchPermission ||
      props.isGroupEditor ||
      (props.activeBranchId && props.isBranchOrGroupOwner),
    viewedActivityStr: props.viewedActivityStr,
  });

  if (props.activeBranchId && props.employments) {
    mountBranchSelectorComponent({
      activeBranchId: props.activeBranchId,
      preferredBranchId: props.preferredBranchId,
      employments: props.employments,
      showMasterButton: props.showMasterButton,
      userId: props.activeUser ? props.activeUser.ID : 0,
      isGroupLevelDashboard: props.isGroupLevelDashboard,
      isGroupOwner: props.isGroupOwner,
      page: props.currentPage,
      initialAreas: props.initialAreas || null,
      groupPermissions: props.groupDashPermissions || null,
    });
  }

  // Display unpaid alert on all pages (on every page load). hasUnpaid will be true for admins and owners with the "Unpaid" perm.
  if (props.hasUnpaid) {
    showUnpaidAlertModal();
  }

  const { isBranchOrGroupOwner, activeUser, userNeedsSurvey } = props;
  if (!activeUser || !isBranchOrGroupOwner) {
    return;
  }

  if (userNeedsSurvey) {
    mountCustomerSurveyModal();
  }

  if (props.activeBranchId && props.activeUser) {
    mountGroupLevelSidebar(props);
  }
}

export function openLogoutModal() {
  window[MODAL_ID.LOGOUT_CONFIRM].openModal();
}

function showUnpaidAlertModal() {
  window["#alert-confirm-modal"].alert("現在、ご入金の確認が取れておりません。ご入金状況の確認をお願いいたします。すでにお手続きいただいている場合は、行き違いの可能性もございますので、何卒ご容赦くださいませ。詳細はサポートチャットもしくはお電話にてお問い合わせください。", false, [], "", "", "未入金");
}

export function reloadOnCondition(slot) {
  if (slot.Repeat || slot.IsHelp) {
    Refresh();
  }
}

export function alertStaffIfVacationMaxedOut(slot) {
  if (isNonWorkingSlotType(slot)) {
    return isVacationLimitMaxedOut();
  }
}

export function updateBadge(type) {
  let badge;

  if (type === NotificationType.BoardNotification) {
    badge = parseInt($("#nav-board").attr("data-badge"));
    badge--;
    if (badge > 0) {
      $("#nav-board").attr("data-badge",badge);
    } else {
      $("#nav-board").removeClass("badge");
    }
  } else {
    if ($("#nav-summary").length == 0) {
      badge = parseInt($("#nav-shift-span").attr("data-badge"));
    } else {
      badge = parseInt($("#nav-summary").attr("data-badge"));
    }
    badge--;
    if (badge > 0) {
      $("#nav-summary").attr("data-badge",badge);
      $("#nav-shift-span").attr("data-badge",badge);
    } else {
      $("#nav-summary").removeClass("badge");
      $("#nav-shift-span").removeClass("badge");
    }
  }
}

export function removeBadge() {
  $("#nav-summary").removeClass("badge");
  $("#nav-shift-span").removeClass("badge");
  $("#nav-board").removeClass("badge");
}

function mountNotificationDropdown(props) {
  const app = createApp(NotificationDropdown, props);
  app.use(i18n);
  window["#notification-dropdown"] = app.mount("#notification-dropdown");
}

export function handleClearSlotInSlotLogMap(slotId) {
  clearSlotInSlotLogMap(slotId);
}

export function handleUpdateSlotUnreadCommentBadge(slotId, numComments = 0) {
  updateSlotUnreadCommentBadge(slotId, numComments);
}

export function openGroupLevelSidebar() {
  document.getElementById("sidebar").classList.remove("sidebar-close");
  sessionStorage.setItem("sidebar", "opened");
}

export function closeGroupLevelSidebar() {
  document.getElementById("sidebar").classList.add("sidebar-close");
  sessionStorage.setItem("sidebar", "closed");
}

function mountGroupLevelSidebar(props) {
  const groupLevelSidebar = document.querySelector("#group-level-sidebar-content");
  if (!groupLevelSidebar) {
    return;
  }

  const app = createApp(GroupLevelSidebar);
  new GroupLevelSidebarApp(app, props.activeBranchId, props.activeUser.ID, props);
  app.mount("#group-level-sidebar-content");
}

function mountToast() {
  const app = createApp(Toast);
  app.mount("#toast")
}

// HubSpot's chat widget injects cross-origin iframes (js-na2.usemessages.com,
// app-na2.hubspot.com) that don't send their own Cross-Origin-Resource-Policy/COEP
// header, so the browser blocks them once this page's COEP is active. Marking those
// iframes `credentialless` opts them into an isolated, credential-less load that
// satisfies COEP without needing HubSpot's iframes to send a matching header, and
// without weakening the site-wide COEP policy.
function watchForHubSpotIframes() {
  function markCredentialless(iframe) {
    if (/(^|\.)(hubspot\.com|usemessages\.com)$/.test(new URL(iframe.src, location.href).hostname) && !iframe.credentialless) {
      iframe.credentialless = true;
      iframe.src = iframe.src;
    }
  }

  Array.prototype.slice.call(document.querySelectorAll("iframe")).forEach(markCredentialless);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes") {
        if (mutation.target instanceof HTMLIFrameElement) {
          markCredentialless(mutation.target);
        }
        return;
      }
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        var candidates = node.matches("iframe") ? [node] : Array.prototype.slice.call(node.querySelectorAll("iframe"));
        candidates.forEach(markCredentialless);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["src"] });
}
